<template>
    <div class="white-box mt-3">
        <div class="data-group">
            <div class="flex space-between column-mobile">
                <div class="white-button">
                    <a href="/documents/sme_definition_user_guide_ro.pdf" download>
                        Descarcă &nbsp;<strong>Manualul utilizatorului pentru definiția IMM-urilor</strong> / Comisia Europeană
                    </a>
                </div>
                <M3FormTitle title="Tip companie" :checked="checked"></M3FormTitle>
            </div>
            <M3Warn
                type="blue"
                :text="'În temeiul art. 27 alin. (1) şi (2) din Legea concurenţei nr. 21/1996, republicata, şi al art. 30 alin. (1) din Legea nr. 143/1999 privind ajutorul de stat, republicata, Consiliul Concurenţei adoptă prezentele instrucţiuni : Întreprindere legată este întreprinderea care face parte dintr-un grup, prin controlul direct sau indirect al majorităţii drepturilor de vot sau al capitalului social, inclusiv prin acorduri, sau, în anumite cazuri, prin intermediul acţionarilor, persoane fizice, ori prin posibilitatea de a exercita o influenţă dominantă asupra unei întreprinderi.'"
            ></M3Warn>
            <M3Warn
                type="yellow"
                :text="'<strong>ATENȚIE! Vă rugăm să alegeți tipul companiei.</strong> În cazul în care compania se încadrează în categoria întreprinderilor legate sau partenere te rugăm să ai în vedere completarea anexelor suplimentare care însoțesc ANEXA 2.4 - Platforma Smis® analizează prin Termene® dacă in compania dumneavoastră există alte companii care au calitatea de asociați. Din păcate, nu putem identifica dacă compania ta are calitatea de asociat în alte companii. Te rugăm astfel, în urma analizei tale, să alegi mai jos opțiunea corectă pentru tine.'"
            ></M3Warn>
            <M3Warn
                type="yellow"
                :text="'<strong>ATENȚIE! În cazul în care reprezentați o firma legată sau parteneră,</strong> vă rugăm să analizați cu atenție prevederile legii Nr. 346 din 14 iulie 2004\n'+
                    'privind stimularea înfiinţării şi dezvoltării întreprinderilor mici şi mijlocii, în special Art. 6 (alin) (6) Datele, inclusiv numărul mediu anual de salariaţi, ale unei întreprinderi partenere sau legate cu o altă întreprindere se vor stabili pe baza situaţiilor financiare anuale şi a altor date ale întreprinderii ori, dacă există, pe baza situaţiilor financiare anuale consolidate în care întreprinderea este inclusă, care se vor cumula cu datele oricărei întreprinderi partenere a întreprinderii în cauză, situată imediat în amonte sau în aval de aceasta, proporţional cu procentul de participare la capital ori cu procentul drepturilor de vot (cel mai ridicat dintre aceste procente)\n'"
                class="mb-4"
            ></M3Warn>
            <div class="flex space-between columnMobile mt-4">
                <div class="tip" :class="{ 'selected': selected === 1 }">
                    <div class="tip-companie">
                        <span class="title">ÎNTREPRINDERE AUTONOMĂ</span>
                        <p>Intreprinderea dumneavoastra este total independenta, de exemplu nu detine capital social sau drepturi de vot in nici o alta intreprindere si nici o alta intreprindere nu detine capital social sau drepturi de vot in intreprinderea dvs.</p>
                        <p>Detine mai putin de 25% din capitalul social sau din drepturile de vot (oricare dintre acestea e mai mare) in una sau mai multe intreprinderi si/sau o alta intreprindere nu detine mai mult din 25% din capitalul social sau din drepturile de vot in intreprinderea dvs</p>

                        <div class="image">
                            <img src="@/assets/images/M3/M3Sketch/tip1.png" class="title-icon">
                        </div>
                    </div>
                    <div class="tip-button" :class="selected === 1 ? 'green-button-background' : ''" @click="completeForm(1)">
                        <span v-if="selected !== 1">Alege întreprindere autonomă</span>
                        <span v-if="selected === 1">Ai ales întreprindere autonomă</span>
                    </div>
                    <div v-if="sugested === 'autonoma'" class="sugested">
                        Analiza noastră te încadrează aici
                        <font-awesome-icon :icon="['fas', 'chevron-up']"></font-awesome-icon>
                    </div>
                </div>
                <div class="tip" :class="{ 'selected': selected === 2 }">
                    <div class="tip-companie">
                        <span class="title">ÎNTREPRINDERE PARTENERĂ</span>
                        <p>Acest tip de relatie se refera la situatia in care se realizeaza parteneriate financiare majore cu
                            alte intreprinderi, fara ca una dintre intreprinderi sa aiba control direct sau indirect asupra celeilalte. Intreprinderile partenere sunt intreprinderile care nu sunt nici autonome, nici legate una de cealalta.</p>

                        <p>Sunteti o intreprindere partenera daca:</p>

                        <p>Capitalul social si/sau drepturile de vot detinute la cealalta firma sunt egale sau mai
                            mari de 25%, si/sau alta firma detine mai mult de 25% din capitalul social sau drepturile de vot ale firmei dumneavoastra</p>

                        <p>Drepturile de vot detinute in cealalta intreprindere sa nu fie mai mari de 50% ( si vice versa)</p>

                        <div class="image">
                            <img src="@/assets/images/M3/M3Sketch/tip2.png" class="title-icon">
                        </div>
                    </div>
                    <div class="tip-button" :class="selected === 2 ? 'green-button-background' : ''" @click="completeForm(2)">
                        <span v-if="selected !== 2">Alege întreprindere parteneră</span>
                        <span v-if="selected === 2">Ai ales întreprindere parteneră</span>
                    </div>
                    <div v-if="sugested === 'partenera'" class="sugested">
                        Analiza noastră te încadrează aici
                        <font-awesome-icon :icon="['fas', 'chevron-up']"></font-awesome-icon>
                    </div>
                    <div v-if="selected === 2" class="sugested-error">
                        Atenție, sunt necesare completări
                        <font-awesome-icon :icon="['fas', 'chevron-down']"></font-awesome-icon>
                    </div>
                </div>
                <div class="tip" :class="{ 'selected': selected === 3 }">
                    <div class="tip-companie">
                        <span class="title">ÎNTREPRINDERE LEGATĂ</span>
                        <p>Acest tip de relatie corespunde situatiei economice a intreprinderilor care formeaza un grup prin controlul direct sau indirect al majoritatii drepturilor de vot al unei intreprinderi sau prin abilitatea de a exersa o influenta dominanta asupra unei intreprinderi. Aceste cazuri sunt mai putin frecvente decat celalalte doua cazuri.</p>

                        <p>O intreprindere detine majoritatea actiunilor sau drepturilor de vot la o alta
                            intreprindere.</p>

                        <p>O intreprindere are dreptul de a numi sau demite majoritatea persoanelor din consiliul de administratie, conducerea intreprinderii sau organismele de supraveghere ale altei intreprinderi.</p>

                        <p>Contractul dintre intreprinderi sau o clauza din actul constitutiv sau statutul uneia dintre intreprinderi, permite uneia dintre intreprinderi sa exercite o influenta  dominanta asupra celeilalte.</p>

                        <p>O intreprindere are posibilitatea prin acord de a exercita controlul asupra actiunilor sau majoritatii drepturilor de vot din cealalta intreprindere.</p>

                        <div class="image">
                            <img src="@/assets/images/M3/M3Sketch/tip3.png" class="title-icon">
                        </div>
                    </div>
                    <div class="tip-button" :class="selected === 3 ? 'green-button-background' : ''" @click="completeForm(3)">
                        <span v-if="selected !== 3">Alege întreprindere legată</span>
                        <span v-if="selected === 3">Ai ales întreprindere legată</span>
                    </div>
                    <div v-if="sugested === 'legata'" class="sugested">
                        Analiza noastră te încadrează aici
                        <font-awesome-icon :icon="['fas', 'chevron-up']"></font-awesome-icon>
                    </div>
                    <div v-if="selected === 3" class="sugested-error">
                        Atenție, sunt necesare completări
                        <font-awesome-icon :icon="['fas', 'chevron-down']"></font-awesome-icon>
                    </div>
                </div>
            </div>
            <p class="info-tip-text">Sugestia noastră a fost generată pe baza asociațiilor identificați pentru firma dumneavoastră. Vă rugăm să analizați opțiunile și să o alegeți pe cea potrivită.</p>
            <div v-if="selected === 2 || selected === 3" class="needs-revisions">
                <div class="red-warn">
                    <b-icon-info-circle></b-icon-info-circle>
                    <p><strong>ATENȚIE! În cazul în care reprezentați o firmă legată sau parteneră, se va completa formularul B, precum şi fişele adiţionale. Aplicația POCSketch nu va genera declaraţia Privind asimilarea și încadrarea solicitantului în categoria  întreprinderilor mici şi mijlocii. Aceasta va trebui întocmită manual. Vă mulțumim pentru înțelegere.</strong></p>
                </div>
                <a href="/documents/ANEXA 2.4_Declarație încadrare în categoria IMM.docx" download class="download-icon">
                    <p>Descarcă Anexa specifică firmelor legate sau partenere</p>
                    <img src="@/assets/images/M3/M3Sketch/download-icon-red.png" alt="">
                </a>
                <p><strong>Vă rugăm să selectați manual categoria în care se încadrează compania:</strong></p>
                <p>Opțiunea ta va modifica structura bugetului (cofinanțare)</p>
                <validation-observer #default="{ invalid }" ref="observer">
                    <span class="display-none">{{ invalid }}</span>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                    >
                        <div @click="checkCompleted()">
                            <b-form-radio-group
                                id="radio-group-1"
                                v-model="tipImm"
                                :options="immTypeOptions"
                                :state="errors[0] ? false : null"
                                name="radio-options"
                                :class="completed ?'disabled-radio':''"
                                class="radio-check mt-2 mb-2"
                            ></b-form-radio-group>
                        </div>
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </validation-observer>
                <b-form-checkbox
                    v-model="completed"
                    switch
                    size="lg"
                    class="switch-box"
                    @change="sendImmType(completed)"
                >Informațiile sunt complete și corecte</b-form-checkbox>
            </div>
        </div>
    </div>
</template>

<script>
    import {BIconInfoCircle, BFormRadioGroup, BFormCheckbox} from 'bootstrap-vue';
    import M3FormTitle from '../M3FormTitle'
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faChevronDown, faChevronUp} from '@fortawesome/free-solid-svg-icons'
    import {faFacebookMessenger, faWhatsapp} from "@fortawesome/free-brands-svg-icons";
    import _ from "lodash";
    import M3Warn from '@/pages/Aplicatii/M3/M3Sketch/components/M3Warn'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    require('@/helpers/validations/validations')
    library.add(faChevronUp, faChevronDown, faFacebookMessenger, faWhatsapp)
    export default {
        components: {
            M3FormTitle,
            FontAwesomeIcon,
            M3Warn,
            BIconInfoCircle,
            BFormRadioGroup,
            BFormCheckbox,
            ValidationProvider,
            ValidationObserver
        },

        props: {
            enterprise: null,
            activeCompany: null,
            asociatiFirma: null,
            immType: null,
            companies: null,
            immUp: null
        },

        data() {
            return {
                checked: null,
                selected: 0,
                sugested: '',
                completed: false,
                tipImm: '',
                immTypeOptions: [
                    { value: 'micro', text: 'Micro întreprindere - 5% cofinanțare' },
                    { value: 'mică', text: 'Întreprindere mică - 10% cofinanțare ' },
                    { value: 'mijlocie', text: 'Înreprindere mijlocie - 15% cofinanțare ' },
                ],
            }
        },
        watch:{
            asociatiFirma:function () {
            },
            companies: {
                handler: function () {
                    this.getRecommendedType()
                },
                deep: true
            },
            immUp:function () {
                this.tipImm = this.immUp
            },
            enterprise: {
                handler () {
                    if(this.enterprise) {
                        this.selected = this.enterprise;
                        this.$emit('formComplete');
                        this.checked = true;
                    }
                },
                deep: true,
                immediate: true
            },
            immType: {
                handler() {
                    this.tipImm = this.immType
                    if(this.tipImm && this.enterprise){
                        this.completed = true
                    }
                },
                deep: true
            }
        },

        mounted() {
            this.tipImm = this.immType
            if(this.tipImm && this.enterprise){
                this.completed = true
            }
        },
        methods: {
            completeForm(selected) {
                if(this.selected){
                    this.$emit('formIncomplete');
                }
                this.selected = selected;
                this.$store.dispatch('m3Sketch/saveAllDataPart', { enterprise_type: selected })
                    .then((response) => {
                        this.$toast.success(response.data.message)
                        this.$emit('formComplete');
                    }).catch((xhr) => {
                        if (xhr.status === 422) {
                            this.errors.record(xhr.responseJSON.errors);
                        }
                        this.$toast.error(xhr.response.data.message);
                    });
                this.checked = true
            },
            sendImmType() {
                this.$refs.observer.validate().then((e) => {
                    if (!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {
                        this.$store.dispatch('m3Sketch/saveAllDataPart', {imm_type: this.tipImm})
                            .then((response) => {
                                this.$toast.success(response.data.message)
                                this.$emit('companyTypeChanged', this.tipImm)
                            }).catch((xhr) => {
                                if (xhr.status === 422) {
                                    this.errors.record(xhr.responseJSON.errors);
                                }
                                this.$toast.error(xhr.response.data.message);
                            });
                    }
                })
            },
            checkCompleted() {
                if(this.completed){
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                }
            },
            getRecommendedType() {
                let businesses = _.filter(this.asociatiFirma, v => v.cui && v.procentaj >= 25)
                let persons = _.filter(this.asociatiFirma, v => !v.cui)
                let companies25 = _.filter(this.companies, v => (v.percentage && v.percentage.includes('%') ? Number(v.percentage.slice(0, -1)) : v.percentage) >= 25)
                let companies50 = _.filter(this.companies, v => (v.percentage && v.percentage.includes('%') ? Number(v.percentage.slice(0, -1)) : v.percentage) >= 50)
                if(persons.length > 0 && businesses.length < 1 && companies25.length < 1 && companies50.length < 1){
                    this.sugested = 'autonoma'
                } else if((businesses.length > 0 || companies25.length > 1) && companies50.length < 1){
                    this.sugested = 'partenera'
                } else if(companies50.length > 1) {
                    this.sugested = 'legata'
                } else{
                    this.sugested = 'legata'
                }

            }
        }
    }
</script>

<style scoped>
.white-box{
    background: #fff;
    padding: 20px;
    padding-bottom: 20px !important;
    position: relative;
}
.data-group{
    margin: auto;
    width: 90%;
    position: relative;
}
.disabled-radio{
    pointer-events: none;
}
.green-button-background{
    background-color: #01e8c6 !important;
}
.info-tip-text{
    margin-top: 30px;
}
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.white-button a{
    font-size: 12px;
    color: #777e90;
    padding: 15px 20px;
    border: 1px solid #777e90;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 40px;
    cursor: pointer;
    transition: 0.3s;
}
.white-button a:hover{
    background: #777e90;
    color: #fff;
    text-decoration: none;
}
.warn p{
    margin: 0;
    font-size: 12px;
    color: #777e90;
}
.warn p:first-child{
    font-weight: 500;
    font-size: 14px;
}
.tip-companie{
    padding: 20px 25px 45px 25px;
    border-radius: 6px;
    border: 1px solid #cbced5;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 320px;
    height: auto;
    min-height: 1043px;
}
.selected .tip-companie{
    border: 3px solid #01e8c6;
    box-shadow: 0 0 3px #01e8c6;
}
.tip-button{
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0f1a2f;
    background: #d6e3e6;
    padding: 6px 20px;
    border-radius: 6px;
    margin-top: 15px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
}
.tip{
    height: 100%;
}
.sugested{
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: #0AADB2;
    padding: 6px 20px;
    border-radius: 6px;
    margin-top: 15px;
    font-size: 14px;
    font-weight: 500;
    position: relative;
}
.sugested-error{
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: #f88c9b;
    padding: 6px 20px;
    border-radius: 6px;
    margin-top: 15px;
    font-size: 14px;
    font-weight: 500;
    position: relative;
}
.sugested svg, .sugested-error svg{
    position: absolute;
    right: 10px;
    top: 0;
    bottom: 0;
    margin: auto 0;
    font-size: 18px;
    transition: 0.3s;
}
.sugested:hover svg{
    bottom: 5px;
}
.sugested-error:hover svg{
    bottom: -5px;
}
.bold{
    font-weight: 700;
}
.tip-companie .title{
    font-size: 12px;
    font-weight: 600;
    color: #777e90;
    margin-bottom: 20px;
}
.tip-companie p{
    text-align: justify;
    font-size: 12px;
    color: #777e90;
    margin-bottom: 15px;
}
.tip-companie .item{
    font-size: 12px;
    font-weight: 600;
    color: #777e90;
    margin-bottom: 40px;
}
.red-warn{
    display: flex;
    background: #f88c9b;
    padding: 15px;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    margin: 30px 0;
}
.red-warn p{
    color: #fff;
    font-size: 12px !important;
}
.red-warn svg{
    font-size: 30px;
    margin-right: 20px;
}
.download-icon{
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 500px;
    cursor: pointer;
    margin-bottom: 35px;
}
.download-icon p{
    color: #f88c9b;
    font-size: 16px !important;
}
.download-icon:hover{
    text-decoration: none;
}
.radio-check{
    display: flex;
    flex-direction: column;
}
.needs-revisions p{
    font-size: 16px;
}
.switch-box{
    text-align: right;
    margin-top: 25px;
}
.switch-box >>> input, .switch-box >>> label{
    cursor: pointer;
}
@media (max-width: 1700px){
    .white-box{
        padding: 20px 35px !important;
    }
    .columnMobile{
        flex-direction: column;
    }
    .tip, .tip-companie{
        max-width: 100%;
        width: 100%;
    }
    .tip{
        margin-bottom: 30px;
    }
}
@media only screen and (max-width: 1536px) {
  .tip-companie {
    min-height: auto;
  }
}
@media only screen and (max-width: 1367px) {
  .white-button a {
    font-size: 11px;
  }
  .info-tip-text {
    margin-top: 0px;
  }
}
@media only screen and (max-width:1281px){
  .column-mobile {
    flex-direction: column;
  }
}
@media screen and (max-width: 1150px) {
    .white-button a {
        font-size: 11px;
    }
}
</style>
